import { render, staticRenderFns } from "./RegisterSection.vue?vue&type=template&id=13e51a0a&"
import script from "./RegisterSection.vue?vue&type=script&lang=js&"
export * from "./RegisterSection.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSection.vue?vue&type=style&index=0&id=13e51a0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports